<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <COIRequests title="COI Requests"></COIRequests>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import COIRequests from "./Tables/COIRequests";
export default {
  name: "CoiRequests",
  components: {
    COIRequests,
  },
};
</script>
<style></style>
